import { Loadable } from '..';
import { HashMap } from '../../constants';
import { BundleAlertDefinition } from '../transfer/input/BundleAlertDefinition';

/**
 * The number of seconds the application will wait before refreshing Command Definitions from the server.
 */
export const BundleAlertDefinitionsCacheTimeout = 300;

export interface BundleAlertDefinitions {
  filter: number | string;
  all: BundleAlertDefinition[];
  byId: HashMap<BundleAlertDefinition>;
  byType: HashMap<BundleAlertDefinition>;
}

export type BundleAlertDefinitionsState = Loadable<BundleAlertDefinitions>;

export const getDefaultBundleAlertDefinitionState = (): BundleAlertDefinitionsState => {
  return {
    filter: 0,
    all: [],
    byId: {},
    byType: {},
    isLoading: false,
  };
};
